import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-5",
  "use": "icon-icon-nav-5-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-5\"><path d=\"M698.688 176H325.312c-41.024 0-74.24 33.6-74.24 74.688l-0.384 597.312L512 736l261.312 112V250.688a74.88 74.88 0 0 0-74.624-74.688z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-5.svg
// module id = CUM2
// module chunks = 3